import { useEffect, useState, useCallback, useRef, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { debounce } from 'utils/common';
import {  useSelector } from 'react-redux';
import {toTitleCase} from "utils/common"

export default function useEmployeeFilter(pageSettings , setPageSettings) {
    const [searchParams, setSearchParams] = useSearchParams();
    const {
        department, departmentLoading,
        reportTo, reportToLoading,
        nationality, nationalityLoading,
        position, positionLoading,
        division, divisionLoading,
        
    } = useSelector((state) => state.common);

    const [filterLoading, setFilterLoading] = useState(false)
  const [filters, setFilters] = useState([
    {
        key: "search",
        label: "Search term",
        value: searchParams.get("search") || ""
    },
    {
        key: "employment_date_after",
        label: "Joined after",
        value: searchParams.get("employment_date_after") || ""
    },
    {
        key: "employment_date_before",
        label: "Joined before",
        value: searchParams.get("employment_date_before") || ""
    },
    {
        key: "gender",
        label: toTitleCase(searchParams.get("gender") || ""),
        value: searchParams.get("gender") || ""
    },
    {
        key: "report_to",
        label: "",
        value: searchParams.get("report_to") || ""
    },
    {
        key: "department",
        label: "",
        value: searchParams.get("department") || ""
    },
    {
        key: "nationality",
        label: "",
        value: searchParams.get("nationality") || ""
    },
    {
        key: "position",
        label: "",
        value: searchParams.get("position") || ""
    },
    {
        key: "division",
        label: "",
        value: searchParams.get("division") || ""
    },
    {
        key: "marital_status",
        label: toTitleCase(searchParams.get("marital_status") || ""),
        value: searchParams.get("marital_status") || ""
    },
    {
        key: "cost_center",
        label: toTitleCase(searchParams.get("cost_center") || ""),
        value: searchParams.get("cost_center") || ""
    },
    {
        key: "status",
        label: toTitleCase(searchParams.get("status") || ""),
        value: searchParams.get("status") 
    },
    {
        key: "eos_approved",
        label: toTitleCase(searchParams.get("eos_approved") || ""),
        value: searchParams.get("eos_approved") || ""
    },
    {
        key: "resigned_date_after",
        label: "Resigned after",
        value: searchParams.get("resigned_date_after") || ""
    },
    {
        key: "resigned_date_before",
        label: "Resigned before",
        value: searchParams.get("resigned_date_before") || ""
    }
  ]);

  useEffect(()=>{

    if(!departmentLoading && !reportToLoading && !nationalityLoading && !positionLoading && !divisionLoading && department.length && reportTo.length && nationality.length && position.length && division.length){
        let gender = searchParams.get("gender") || ""
        let nationalityParams = searchParams.get("nationality") || ""
        // console.log(nationalityParams, "nationalityParams", searchParams.getAll("nationality"))

        if(nationalityParams){
            nationalityParams = nationalityParams.split(",")
        }else{
            nationalityParams = []
        }
        console.log(nationalityParams, "nationality")

        let selectedReportTo = [...reportTo].find(item=>item.user_id == searchParams.get("report_to") || "")
        let selectedDepartment = [...department].find(item=>item.id == searchParams.get("department") || "")
        let selectedNationality = [...nationality].filter(item=> nationalityParams.includes(item.id.toString()))
        console.log(selectedNationality, nationality,nationalityParams,"selectedNationality")
        let selectedPosition = [...position].find(item=>item.id == searchParams.get("position") || "")
        let selectedDivision = [...division].find(item=>item.id == searchParams.get("division") || "")
        let selectedMarital = searchParams.get("marital_status") || ""
        let selectedCostCenter = searchParams.get("cost_center") || ""
        let selectedStatus = searchParams.get("status") || ""
        let selectedEos = searchParams.get("eos_approved") || ""
        console.log(selectedStatus, "---SELECTED STATUS")
        let _filters = [
            {
                key: "search",
                label: "Search term",
                value: searchParams.get("search") || ""
            },
            {
                key: "employment_date_after",
                label: "Joined after",
                value: searchParams.get("employment_date_after") || ""
            },
            {
                key: "employment_date_before",
                label: "Joined before",
                value: searchParams.get("employment_date_before") || ""
            },
            {
                key: "gender",
                label: toTitleCase(gender),
                value: gender || ""
            },
            {
                key: "report_to",
                label: selectedReportTo?.first_name,
                value: searchParams.get("report_to") || ""
            },
            {
                key: "department",
                label: selectedDepartment?.name,
                value: searchParams.get("department") || ""
            },           
            {
                key: "position",
                label: selectedPosition?.name,
                value: searchParams.get("position") || ""
            },
            {
                key: "division",
                label: selectedDivision?.name,
                value: searchParams.get("division") || ""
            },
            {
                key: "marital_status",
                label: toTitleCase(selectedMarital),
                value: selectedMarital
            },
            {
                key: "cost_center",
                label: toTitleCase(selectedCostCenter),
                value: selectedCostCenter
            },
            {
                key: "status",
                label: toTitleCase(selectedStatus),
                value: selectedStatus || ""
            },
            {
                key: "eos_approved",
                label: toTitleCase(selectedEos),
                value: selectedEos || ""
            },
            {
                key: "resigned_date_after",
                label: "Resigned after",
                value: searchParams.get("resigned_date_after") || ""
            },
            {
                key: "resigned_date_before",
                label: "Resigned before",
                value: searchParams.get("resigned_date_before") || ""
            }
          ]

          if(selectedNationality.length){
            let nationalities = selectedNationality.map(item => {
                return { value: item.id,
                label: item.name}
            })
            _filters.push(
                {
                    key: "nationality",
                    label: "Nationality",
                    value: nationalities
                },
            )

          }else{
            _filters.push(
                {
                    key: "nationality",
                    label: "Nationality",
                    value: ""
                }
            )
          }
          setFilters(_filters)
    }

 
  },[
    department,
    reportTo,
    nationality,
    position,
    division
  ])

  const handleFilterChange =  (data, key, make_call=false) => {

    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    
    // console.log(data , "====data")
    // console.log(_filters , "====_filters")

    if(Array.isArray(data)){
        // selectedFilter['label'] = data?.label || ""
        selectedFilter['value'] = data

    }else{
        selectedFilter['label'] = data?.label || ""
        selectedFilter['value'] = data?.value ?? ""
    }


    setFilters(_filters)
    console.log( _filters, "AAAA")
    if(make_call){
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters
    
        })
    }


    
  };
  // Use ref to always have access to latest values without causing re-renders
  const pageSettingsRef = useRef(pageSettings);
  const filtersRef = useRef(filters);
  
  useEffect(() => {
    pageSettingsRef.current = pageSettings;
    filtersRef.current = filters;
  }, [pageSettings, filters]);

  // Memoize the debounced function so it's created only once
  const handleInputChange = useMemo(() => 
    debounce((data, key, make_call=false) => {
      console.log( "FFFF")

      // Use functional update to get the latest filters
      setFilters(prevFilters => {
        const _filters = [...prevFilters]
        const selectedFilter = _filters.find(item=> item.key === key)
        if (selectedFilter) {
          selectedFilter['label'] = key
          selectedFilter['value'] = data
        }

        if(make_call){
          // Use ref to get latest pageSettings
          setPageSettings({
            ...pageSettingsRef.current,
            page:1,
            filters: _filters
          })
        }

        return _filters
      })
    }, 1000)
  , [setPageSettings]) // Only recreate if setPageSettings changes (which it shouldn't)

  const handleDateChange = (data, key, make_call=false) => {

    console.log("---filterssss--->>>>", [...filters])
    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = key
    selectedFilter['value'] = data
    setFilters(_filters)

    if(make_call){

        
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters
    
        })
    }

  }

  return {
    handleFilterChange,
    filters,
    handleInputChange,
    filterLoading, setFilterLoading,
    handleDateChange
  };
}
